var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-table",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "multipleTable",
      staticClass: "yxtbiz-eval-evaluator-table",
      staticStyle: { width: "100%" },
      attrs: {
        data: _vm.customFilterDatas || _vm.customDatas,
        "row-key": "id",
        border: _vm.border,
      },
      on: { "selection-change": _vm.handleSelectionChange },
    },
    [
      _vm.multiple
        ? _c("yxt-table-column", {
            attrs: {
              type: "selection",
              "class-name": "selection-col",
              "reserve-selection": "",
              width: _vm.border ? 48 : 40,
            },
          })
        : _vm._e(),
      _vm.tableType === "eval"
        ? _c("yxt-table-column", {
            attrs: {
              prop: "fullname",
              label: _vm.$t("pc_gwnl_global_lbl_name"),
              width: "300",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "mb4 font-weight-600" },
                        [
                          _c("yxtbiz-user-name", {
                            attrs: { name: scope.row.fullname },
                          }),
                          _vm._v(
                            "\n        (" +
                              _vm._s(scope.row.username) +
                              ")\n      "
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "color-gray-7" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(scope.row.positionName || "--") +
                            "\n      "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "color-gray-7" },
                        [
                          _c("dept-cell", {
                            attrs: { "dept-name": scope.row.deptName },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              2078774027
            ),
          })
        : _vm._e(),
      _vm.tableType === "dynamic"
        ? _c("yxt-table-column", {
            attrs: {
              prop: "fullname",
              label: _vm.$t("pc_gwnl_global_lbl_name"),
              width: "150",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "mb4 font-weight-600" },
                        [
                          _c("yxtbiz-user-name", {
                            attrs: { name: scope.row.fullname },
                          }),
                          _vm._v(
                            "\n        (" +
                              _vm._s(scope.row.username) +
                              ")\n      "
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              2833398399
            ),
          })
        : _vm._e(),
      _vm.tableType === "dynamic"
        ? _c("yxt-table-column", {
            attrs: { prop: "positionName", label: "岗位", width: "150" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", { staticClass: "color-gray-7" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(scope.row.positionName || "--") +
                            "\n      "
                        ),
                      ]),
                    ]
                  },
                },
              ],
              null,
              false,
              1219692974
            ),
          })
        : _vm._e(),
      _vm.tableType === "dynamic"
        ? _c("yxt-table-column", {
            attrs: { prop: "deptName", label: "部门", width: "150" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "color-gray-7" },
                        [
                          _c("dept-cell", {
                            attrs: { "dept-name": scope.row.deptName },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              3100723418
            ),
          })
        : _vm._e(),
      _c("yxt-table-column", {
        attrs: {
          label: _vm.$t("pc_gwnl_global_lbl_assessor"),
          "class-name": "gwnl-evaluator__td",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c("evaluator-cell", {
                  attrs: {
                    row: scope.row,
                    validate: _vm.validate,
                    showWeight: _vm.showWeight,
                    functionCode: _vm.functionCode,
                    dataPermissionCode: _vm.dataPermissionCode,
                    "is-save": _vm.isSave,
                    id: _vm.id,
                    dynamicChoose: _vm.dynamicChoose,
                  },
                  on: {
                    "update-evaluate": function ($event) {
                      return _vm.handleUpdateEvaluate($event, scope.row)
                    },
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }